//导入加密JS
import CryptoJS from "crypto-js";
//导入工具JS
import {
    tpyeofon
} from "./crypoto"
//密钥，需为长度为 16 的字符串
const key = CryptoJS.enc.Utf8.parse("aes_key_ppqd_api");
//向量
const iv = CryptoJS.enc.Utf8.parse('1234567896666666');
export default {
    /**
     * MD5（32位小写）
     * @param {String|Object} data 需要MD5的数据 
     */
    md5(data: any) {
        data = typeof (data) == 'object' ? JSON.stringify(data) : data;
        return CryptoJS.MD5(data).toString();
    },
    /**
     * AES加密
     * @param {String|Object} data 需要加密的数据
     */
    aesEncrypty(data: any) {
        data = typeof (data) == 'object' ? JSON.stringify(data) : data;
        let srcs = CryptoJS.enc.Utf8.parse(data);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    /**
     * AES解密
     * @param {String} data 需要解密的数据 
     */
    aesDecrypt(data: any) {


        let decrypt = CryptoJS.AES.decrypt(data, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    },
    /**
     * BASE64 加密
     * @param {String} data 需要处理的数据
     */
    base64Encrpty(data: any) {
        if (tpyeofon.isEmpty(data)) {
            return '';
        }
        let dataArray = CryptoJS.enc.Utf8.parse(data);
        return CryptoJS.enc.Base64.stringify(dataArray);
    },
    /**
     * BASE64 解密
     * @param {String} data 需要解密的数据 
     */
    base64Decrypt(data: any) {
        if (tpyeofon.isEmpty(data)) {
            return '';
        }
        let parsedDataArray = CryptoJS.enc.Base64.parse(data);
        return parsedDataArray.toString(CryptoJS.enc.Utf8);
    },
    uuid(): string {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16 | 0;
                const v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }
        );
    }

}